export enum AsTypes {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6',
    p = 'p',
    q = 'q',
    span = 'span',
    div = 'div',
}
export type TypographyPropAs = keyof typeof AsTypes;

export enum TypographyVariantTypes {
    'headline-xl' = 'headline-xl',
    'headline-lg' = 'headline-lg',
    'headline-md' = 'headline-md',
    'headline-sm' = 'headline-sm',
    'headline-xs' = 'headline-xs',
    'copy' = 'copy',
    'copy-medium' = 'copy-medium',
    'copy-semibold' = 'copy-semibold',
    'copy-small' = 'copy-small',
    'button' = 'button',
    'micro-copy' = 'micro-copy',
    'micro-copy-medium' = 'micro-copy-medium',
    'topline' = 'topline',
    'navigation-main' = 'navigation-main',
    'navigation-meta' = 'navigation-meta',
    'navigation-footer' = 'navigation-footer',
    'navigation-breadcrumb' = 'navigation-breadcrumb',
    'textlink' = 'textlink',
}
